<template>
  <div :class="['wrapper', isVisible ? '' : 'invisible']">
    <slot name="content" />
  </div>
</template>
<script>
export default {
  name: 'Hideshow',
  props: {
    modelValue: {
      type: Boolean,
      value: false
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      timeoutID: null,
      isVisible: this.modelValue
    }
  },
  watch: {
    modelValue: function () {
      this.isVisible = this.modelValue
    },
    isVisible() {
      if (this.isVisible) {
        this.timeoutID = setTimeout(() => {
          this.isVisible = false
        }, this.timeout)
      }
      this.$emit('update:modelValue', this.isVisible)
    }
  },
  created() {
    if (this.isVisible) {
      this.timeoutID = setTimeout(() => {
        this.isVisible = false
      }, this.timeout)
    }
  },
  methods: {
    refresh() {
      this.isVisible = true
      if (this.timeoutID) {
        clearTimeout(this.timeoutID)
        this.timeoutID = null
      }
      this.timeoutID = setTimeout(() => {
        this.isVisible = false
      }, this.timeout)
    }
  }
}
</script>

<style scoped>
.wrapper {
  transition: opacity 0.5s ease;
  opacity: 1;
}

.invisible {
  opacity: 0;
  pointer-events: none;
}
</style>
